/**
 * Created by nijin on 6/11/17.
 */
import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'datex'
})

export class DatexPipe implements PipeTransform {
  transform(value: any, format: string = ""): string {
    // Try and parse the passed value.
    if(!value){
      return
    }
    var momentDate = moment(value);

    // If moment didn't understand the value, return it unformatted.
    if (!momentDate.isValid()) return;

    // Otherwise, return the date formatted as requested.
    return momentDate.format(format);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/ie-workaround/date.pipe.ts